import { render, staticRenderFns } from "./loadingQueue.vue?vue&type=template&id=3af31f5f&"
import script from "./loadingQueue.vue?vue&type=script&lang=js&"
export * from "./loadingQueue.vue?vue&type=script&lang=js&"
import style0 from "./loadingQueue.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports